/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { Environment } from './Environment.js'

export const ProductEntitlement = z.object({
  AGSProductTier: z.enum(['UNKNOWN', 'STARTER', 'PREMIUM']),
  AGSSupportTier: z.enum(['UNKNOWN', 'STANDARD', 'PROFESSIONAL', 'ENTERPRISE']),
  environments: z.array(Environment),
  id: z.string(),
  name: z.string()
})

export interface ProductEntitlement extends z.TypeOf<typeof ProductEntitlement> {}
